import { render, staticRenderFns } from "./CustomWidthProgressBar.vue?vue&type=template&id=646be1a0&"
import script from "./CustomWidthProgressBar.vue?vue&type=script&lang=js&"
export * from "./CustomWidthProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports